import { render, staticRenderFns } from "./VideoDisabledBanner.vue?vue&type=template&id=4652c75b&scoped=true"
import script from "./VideoDisabledBanner.vue?vue&type=script&lang=js"
export * from "./VideoDisabledBanner.vue?vue&type=script&lang=js"
import style0 from "./VideoDisabledBanner.vue?vue&type=style&index=0&id=4652c75b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4652c75b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4652c75b')) {
      api.createRecord('4652c75b', component.options)
    } else {
      api.reload('4652c75b', component.options)
    }
    module.hot.accept("./VideoDisabledBanner.vue?vue&type=template&id=4652c75b&scoped=true", function () {
      api.rerender('4652c75b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/banners/VideoDisabledBanner.vue"
export default component.exports